import { Avatar } from 'antd'

export const CallSummaryAgentMessageItem = ({ data }: any) => {
   return (
      <div className="flex items-end justify-end gap-x-2">
         <div className="flex flex-col justify-between bg-[#594180] py-4 px-5 max-w-[450px] rounded-3xl rounded-br-none gap-y-1">
            <p className="text-[14px] font-medium">{data?.content}</p>
         </div>
         <Avatar
            src={'/images/ff_white.png'}
            className="w-10 h-10 p-1 shrink-0 bg-primary/20"
         >
            {data?.assistant?.name?.slice(0, 1)}
         </Avatar>
      </div>
   )
}
